import React from 'react';
import mark from '../../assets/safehand-mark.png';
import { useLang } from '../../i18n/LanguageContext';

// Illustrative SafeHand transaction screen, drawn in HTML/CSS so it stays sharp and bilingual.
// It shows the workflow (terms → status → evidence → completion), not money custody.
export default function PhoneMockup() {
  const { t } = useLang();
  const m = t.mock;
  const state = ['done', 'done', 'active', 'todo'];

  return (
    <figure className="mock">
      <div className="mock__glow" aria-hidden="true" />
      <div className="phone" aria-hidden="true">
        <div className="phone__notch" />
        <div className="phone__screen">
          <div className="app-bar">
            <img src={mark} alt="" width="28" height="28" />
            <span>SafeHand</span>
            <i className="fa-solid fa-bell" />
          </div>

          <div className="deal-card">
            <div className="deal-card__top">
              <span className="deal-card__id" dir="ltr">#SH-2041</span>
              <span className="pill pill--ok">
                <i className="fa-solid fa-file-signature" /> {m.accepted}
              </span>
            </div>
            <p className="deal-card__item">{m.item}</p>
            <p className="deal-card__price">{m.price}</p>
            <div className="deal-card__parties">
              <span>
                <b className="avatar">A</b>
                {m.buyer}
              </span>
              <i className="fa-solid fa-arrow-right-arrow-left" />
              <span>
                <b className="avatar avatar--alt">M</b>
                {m.seller}
              </span>
            </div>
          </div>

          <ol className="timeline">
            {m.steps.map((s, i) => (
              <li key={s} className={`timeline__step is-${state[i]}`}>
                <span className="timeline__dot">{state[i] === 'done' && <i className="fa-solid fa-check" />}</span>
                {s}
              </li>
            ))}
          </ol>

          <div className="held">
            <i className="fa-solid fa-eye" />
            {m.shared}
          </div>

          <div className="mock-btn">{m.confirm}</div>
        </div>
      </div>

      <div className="float-chip float-chip--a" aria-hidden="true">
        <span className="float-chip__icon">
          <i className="fa-solid fa-file-contract" />
        </span>
        <span>
          <small>{m.chipASmall}</small>
          {m.chipA}
        </span>
      </div>
      <div className="float-chip float-chip--b" aria-hidden="true">
        <span className="float-chip__icon float-chip__icon--ok">
          <i className="fa-solid fa-camera" />
        </span>
        <span>{m.chipB}</span>
      </div>
      <figcaption className="mock__caption">{t.common.illustrative}</figcaption>
    </figure>
  );
}
